<template>
	<div :class="['flex relative items-end', containerClass]">
		<div class="w-18px h-18px border-1 border-border-color rounded">
			<input type="checkbox" class="hidden" :id="id" v-bind="$attrs" :value="innerValue" @change="toggle" />
			<label
				:for="id"
				class="flex w-4 h-4 items-center justify-center z-50"
				:class="!$attrs.disabled ? 'cursor-pointer' : 'cursor-not-allowed'"
			>
				<app-icon icon="save" :class="['text-13 text-black', { hidden: !innerValue }]" />
			</label>
		</div>
		<app-small
			:class="!$attrs.disabled ? 'cursor-pointer' : 'cursor-not-allowed'"
			@click="!$attrs.disabled && toggle()"
		>
			&nbsp;{{ label }}
		</app-small>
	</div>
	<transition name="slide-fade-reverse">
		<span class="error-message text-13 text-error" v-if="validation.meta.touched || validation.errors.length > 0">
			{{ validation.errorMessage }}
		</span>
	</transition>
</template>

<script>
	import AppIcon from './AppIcon';
	import AppSmall from '../typography/AppSmall';

	export default {
		name: 'AppCheckbox',
		components: {
			AppSmall,
			AppIcon,
		},
		emits: ['update:modelValue'],
		props: {
			modelValue: {},
			containerClass: {
				required: false,
				default: 'mb-3',
			},
			label: {
				type: String,
			},
			validation: {
				type: Object,
				default: () => ({
					meta: {},
					errors: [],
				}),
			},
		},
		data: () => ({
			innerValue: false,
		}),
		computed: {
			id() {
				return (Math.random() * 10000).toString().replace('.', '');
			},
		},
		methods: {
			toggle() {
				const newVal = !this.innerValue ? 1 : 0;
				this.innerValue = newVal;
				this.$emit('update:modelValue', newVal);
			},
		},
		mounted() {
			this.innerValue = this.modelValue ? 1 : 0;
		},
		updated() {
			this.innerValue = this.modelValue ? 1 : 0;
		},
	};
</script>
